<template>
 <div class="user-manager-edit">
    <div class="user-manager-edit__tabs">
      <router-link class="user-manager-edit__tabs_tab"
                   :to="{ name: 'UserTab' }"
                   active-class="user-manager-edit__tabs_tab_active">User</router-link>
      <router-link class="user-manager-edit__tabs_tab"
                   :class="{'user-manager-edit__tabs_tab_disabled': isAddNew}"
                   :to="{ name: 'AgencyRolesTab' }"
                   active-class="user-manager-edit__tabs_tab_active">Agency Roles</router-link>
      <router-link class="user-manager-edit__tabs_tab"
                   :class="{'user-manager-edit__tabs_tab_disabled': isAddNew}"
                   :to="{ name: 'ClientRolesTab' }"
                   active-class="user-manager-edit__tabs_tab_active">Clients Roles</router-link>
    </div>

   <base-material-design-icon @click="handleClose" class="user-manager-edit__cross-button" icon="plus"/>

   <div v-if="!isDataFetched && !isAddNew">
     <div class="user-manager-edit__no-data">Awaiting Data</div>
   </div>
   <template v-else>
     <div class="user-manager-edit__content-wrapper">
       <router-view @updateData="loadData"/>
     </div>
   </template>

   <div class="user-manager-edit__update-loader" v-if="isDataUpdating">
     <base-loader class="user-manager-edit__update-loader-ring"/>
   </div>
 </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ToastService from '@/services/toasterService'

export default {
  name: 'Edit',
  async created () {
    !this.isAddNew && await this.loadData()
    if (this.isRolesMissing && !this.isAddNew && !this.isRecentlyAdded) {
      ToastService.showToast(
        ToastService.INFO_TYPE,
        'Please add Agency or Client role for this user'
      )
    }
  },
  destroyed () {
    !this.isAddNew && this.changeIsRecentlyAdded(false)
    this.resetUserManagerData()
  },
  data () {
    return {
      isDataFetched: false,
      isDataUpdating: false
    }
  },
  computed: {
    ...mapState('userManager', {
      isRolesMissing (state) {
        return !state.clientRoles.length && !state.agencyRoles.length
      },
      isRecentlyAdded: 'isRecentlyAdded'
    }),
    userId () {
      return this.$route.params.id
    },
    isAddNew () {
      return this.$route.params.id === 'add-new-user'
    }
  },
  methods: {
    ...mapActions('userManager', ['getUserData', 'changeIsRecentlyAdded', 'resetUserManagerData']),
    async loadData () {
      this.isDataUpdating = true
      try {
        await this.getUserData({ clientId: this.clientId, userId: this.userId })
      } catch (e) {
      }
      this.isDataUpdating = false
      this.isDataFetched = true
      return true
    },
    handleClose () {
      this.$router.push({ name: 'user_manager' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-manager-edit {
    padding: 25px 40px 0;
    position: relative;

    &__tabs {
      display: flex;
      margin-bottom: -1px;

      &_tab {
        width: 110px;
        padding: 16px 0;
        text-align: center;
        font-size: 14px;
        color: $rfx-light-march;
        background-color: transparent;
        border: 1px solid transparent;
        text-decoration: none;

        &_disabled {
          pointer-events: none;
        }

        &_active {
          background-color: #fff;
          color: $rfx-dark-march;
          font-weight: bold;
          border: 1px solid $rfx-light-steel;
          border-bottom: 1px solid #fff;
        }
      }
    }

    &__update-loader {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 74px;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 200px;
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border: 1px solid $rfx-light-steel;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }

    &__content-wrapper {
      border: 1px solid $rfx-light-steel;
      background-color: #fff;
    }

    &__cross-button {
      cursor: pointer;
      font-size: 35px;
      position: absolute;
      right: 34px;
      top: 34px;
      transform: rotate(45deg);
    }
  }
</style>
